<template>
  <v-footer
    absolute
    :height="(SurveyFooter?.$el as HTMLElement)?.getBoundingClientRect().height"
  ></v-footer>
  <v-footer v-if="$route?.meta?.showFooter" app class="pt-0">
    <VRow
      ref="SurveyFooter"
      justify="center"
      align="center"
      class="fill-height pb-1 fill-height"
    >
      <VCol lg="6" md="8" cols="12" class="d-flex align-end justify-end">
        <slot name="prepend"></slot>
        <v-spacer />
        <v-row
          align-content="center"
          class="fill-height mx-2"
          justify="center"
          no-gutters
          style="max-width: 300px"
        >
          <v-col class="text-subtitle-1" cols="12">
            {{ submissionStore.completedPercentageDisplayValue }}%
            <template v-if="$vuetify.display.smAndUp">
              {{ $t('SurveyFooter.complete') }}
            </template>
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              :model-value="submissionStore.completedPercentageDisplayValue"
              height="10"
            />
          </v-col>
        </v-row>
        <v-btn
          v-tooltip="{
            text: $t('SurveyFooter.goBack'),
          }"
          prepend-icon="mdi-arrow-left-thick"
          :disabled="submissionStore.totalCompletedSteps === 0"
          class="back mx-2 bg-voting"
          color="on-voting"
          size="small"
          variant="outlined"
          @click="back"
        >
          {{ $t('SurveyFooter.back') }}
        </v-btn>
        <div v-if="submissionStore.branding" class="mx-2">
          <v-btn
            href="https://opinionx.co"
            target="_blank"
            prepend-icon="mdi-lightning-bolt"
            size="small"
          >
            {{ smAndUp ? 'by OpinionX' : 'OpinionX' }}
          </v-btn>
        </div>
      </VCol>
    </VRow>
  </v-footer>
</template>

<script setup lang="ts">
import { useAnimator } from '@/composables/animator';
import { useSubmissionStore } from '@/stores/submission';
import { onKeyStroke } from '@vueuse/core';
import { ref } from 'vue';
import { useDisplay } from 'vuetify';
import { VRow } from 'vuetify/components';

const { smAndUp } = useDisplay();

const SurveyFooter = ref<VRow | null>();

const { animator } = useAnimator();

const submissionStore = useSubmissionStore();

const back = async (event: KeyboardEvent) => {
  if (
    event.target &&
    ['textarea', 'input'].includes(
      (event.target as HTMLElement).tagName.toLowerCase(),
    )
  ) {
    return;
  }
  if (submissionStore.loading || submissionStore.totalCompletedSteps === 0) {
    return;
  }
  submissionStore.loading = true;
  await animator('.back', 'flash', 'faster');
  submissionStore.back();
  submissionStore.loading = false;
};

onKeyStroke('ArrowLeft', back);
</script>
